import React from 'react';
import './reference.scss';
import { useIntl } from 'react-intl';
import {
  Button,
  Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { localeFormatter } from '../../../utils/formatters';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import Switches from '../../../components/fields/Switches/Switches';

export default function RegistryOfSuspensionReasonsView({
  close = () => {}, handleDelete = () => {}, current = {}, setIsEdit = () => {}, setIsShowForm = () => {},
}) {
  const { formatMessage } = useIntl();
  const {
    procedures = [],
    reasons_types = [],
  } = current;
  return (
    <Dialog
      className="rsr-popup-view"
      onClose={close}
      open
    >
      <DialogTitle header="Просмотр основания" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="rsr-view-content">
        <div className="rsr-view-table">
          <Row className="row-cols-1">
            <Switches
              type="text"
              component={Switches}
              inputProps={{
                value: current.options?.block_180_days,
              }}
              disabled
              label="Блокировка ЛТ на 180 дней"
              variant="material"
              namePrefix="options."
            />
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Наименование основания</Col>
            <Col className="rsr-view-value" columns={8}>{current.name || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Наименование услуги,
              к которой применимо основание
            </Col>
            <Col className="rsr-view-value" columns={8}>
              {(procedures || []).join(', ')}
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Тип действия</Col>
            <Col className="rsr-view-value" columns={8}>
              <ul>
                {(reasons_types || []).map((i, key) => (<li key={key}>{formatMessage({ id: `reason.type.${i}` })}</li>))}
              </ul>
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Связанное обращение</Col>
            <Col className="rsr-view-value" columns={8}>
              <ul>
                {(procedures || []).map((i, key) => (<li key={key}>{formatMessage({ id: `procedure.type.${i}` })}</li>))}
              </ul>
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Норма законодательства</Col>
            <Col className="rsr-view-value" columns={8}>{current.law_number || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Текст сообщения</Col>
            <Col className="rsr-view-value" columns={8}>{current.message || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Дополнительный ответ к тексту сообщения</Col>
            <Col className="rsr-view-value" columns={8}>{current.additional_message || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Тип аргумента</Col>
            <Col className="rsr-view-value" columns={8}>{localeFormatter('reference.argument.type', current.argument_type)}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Значение для аргумента</Col>
            <Col className="rsr-view-value" columns={8}>{current.argument_value || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Сообщение для ЕКДЛ</Col>
            <Col className="rsr-view-value" columns={8}>{current.ekdl_message || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Тип заявителя</Col>
            <Col className="rsr-view-value" columns={8}>
              {current?.legal_entity_types ? current.legal_entity_types?.map(legal_entity_type => localeFormatter('user.type.short', legal_entity_type)).join(', ') : ''}
            </Col>
          </Row>
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <Button variant="link" className="rsr-popup-box-button" onClick={e => { close(); handleDelete(current)(e); }}>
          <Icons customIcon icon="trash" />
        </Button>
        <Button onClick={() => { close(); setIsShowForm(true); setIsEdit(true); }}>Редактировать</Button>
      </DialogFooter>
    </Dialog>
  );
}
